import { render } from "./delivery-status-card.vue?vue&type=template&id=18331ae8&scoped=true&ts=true"
import script from "./delivery-status-card.vue?vue&type=script&lang=ts"
export * from "./delivery-status-card.vue?vue&type=script&lang=ts"

import "./delivery-status-card.vue?vue&type=style&index=0&id=18331ae8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18331ae8"]])

export default __exports__